import { render, staticRenderFns } from "./CompetitionList.vue?vue&type=template&id=07ab1aed&scoped=true"
import script from "./CompetitionList.vue?vue&type=script&lang=js"
export * from "./CompetitionList.vue?vue&type=script&lang=js"
import style0 from "./CompetitionList.vue?vue&type=style&index=0&id=07ab1aed&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ab1aed",
  null
  
)

export default component.exports